/* Global motion from the approved Vercel storefront. */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var splash = document.getElementById('splash');

  function revealHero() {
    document.documentElement.classList.add('hero-in');
  }

  if (splash) {
    var started = Date.now();
    var finished = false;
    var maximum = window.setTimeout(finishSplash, 1800);
    var heroImage = document.querySelector('.hero-media img');
    document.documentElement.style.overflow = 'hidden';

    function finishSplash() {
      if (finished) return;
      finished = true;
      window.clearTimeout(maximum);
      document.documentElement.style.overflow = '';
      splash.classList.add('is-done');
      revealHero();
    }

    Promise.all([
      document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve(),
      new Promise(function (resolve) {
        if (!heroImage || heroImage.complete) return resolve();
        heroImage.addEventListener('load', resolve, { once: true });
        heroImage.addEventListener('error', resolve, { once: true });
      })
    ]).then(function () {
      var delay = reduced ? 0 : Math.max(0, 800 - (Date.now() - started));
      window.setTimeout(finishSplash, delay);
    });
  } else {
    revealHero();
  }

  var revealElements = document.querySelectorAll('.section-head, .fd-head, .fd-item:not(#drop .fd-item), .rv');
  revealElements.forEach(function (element) { element.classList.add('rv'); });

  if ('IntersectionObserver' in window && !reduced) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    revealElements.forEach(function (element) { observer.observe(element); });
  } else {
    revealElements.forEach(function (element) { element.classList.add('is-in'); });
  }

  if (window.gsap && window.ScrollTrigger && !reduced) {
    window.gsap.registerPlugin(window.ScrollTrigger);
    // matchMedia (not a one-off `if (window.innerWidth > 860)`) — that plain
    // check only ever runs once, the instant this script executes, so
    // whatever width the viewport happened to report at that single moment
    // decided the effect's fate for the rest of the page's life. This instead
    // keeps checking: it creates the fade-on-scroll effect only while the
    // viewport is actually desktop-wide, and tears it back down the moment
    // it isn't (including on a resize/preview-frame change), so a mobile
    // screen can never end up with the hero stuck fading like a desktop one.
    if (document.getElementById('hero')) {
      window.ScrollTrigger.matchMedia({
        '(min-width: 861px)': function () {
          window.gsap.to('.hero-media img', {
            scale: 1.12,
            ease: 'none',
            scrollTrigger: { trigger: '#hero', start: 'top top', end: 'bottom top', scrub: 0.6 }
          });
          window.gsap.to('.hero-content', {
            opacity: 0.2,
            y: -50,
            ease: 'none',
            scrollTrigger: { trigger: '#hero', start: 'top top', end: 'bottom top', scrub: 0.6 }
          });
        }
      });
    }
    document.querySelectorAll('[data-parallax]').forEach(function (element) {
      var image = element.querySelector('img');
      if (!image) return;
      window.gsap.to(image, {
        yPercent: parseFloat(element.getAttribute('data-parallax')) || 12,
        ease: 'none',
        scrollTrigger: { trigger: element, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    });
    window.addEventListener('load', function () { window.ScrollTrigger.refresh(); });
  }

  // Returning to the page via the browser's own back/forward cache (common
  // on mobile after tapping into a product/category and hitting back) resumes
  // the exact DOM state frozen at the moment the person left — including any
  // opacity/position GSAP had written directly onto .hero-content mid-scroll
  // (the parallax fade above). Nothing re-runs to reconcile that against the
  // scroll position they're restored to, so it can sit stuck faded even at
  // the very top of the page. Clearing it and asking ScrollTrigger to
  // recompute on this one event fixes that without touching anything else.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    if (window.gsap) {
      window.gsap.set('.hero-content', { clearProps: 'opacity,transform' });
      window.gsap.set('.hero-media img', { clearProps: 'transform' });
    }
    if (window.ScrollTrigger && window.ScrollTrigger.refresh) window.ScrollTrigger.refresh();
  });
})();
